import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';
import type { History } from 'history';
import alertModal from './alert-modal';
import apiError from './api-error';
import bills from './bills';
import customer from './customer';
import dashboard from './dashboard';
import debugLogs from './debug-logs';
import device from './device';
import loadingSpinner from './loading-spinner';
import mobilePushOperation from './mobile-push-operation';
import organization from './organization';
import privateMoney from './private-money';
import qrDesignViewer from './qr-design-viewer';
import qrDesigner from './qr-designer';
import reward from './reward';
import shop from './shop';
import sidebar from './sidebar';
import software from './software';
import softwareRelease from './software-release';
import systemNotification from './system-notification';
import terminal from './terminal';
import transaction from './transaction';
import user from './user';
import userPrivateMoney from './user-private-money';

const rootReducer = (history: History) =>
  combineReducers({
    apiError,
    alertModal,
    loadingSpinner,
    systemNotification,
    dashboard,
    organization,
    user,
    terminal,
    shop,
    customer,
    reward,
    mobilePushOperation,
    transaction,
    device,
    router: connectRouter(history),
    bills,
    qrDesigner,
    sidebar,
    debugLogs,
    qrDesignViewer,
    privateMoney,
    software,
    softwareRelease,
    userPrivateMoney,
  });

export default rootReducer;
